/**
 * Класс, содержащий методы валидации форм
 */
class Validator {
	constructor (form, schema) {
		this.errors = [];
		this.schema = schema;
		this.form = form;
	}

	findInputNode = (name) => {
		return this.form.querySelector(`[name="${name}"]`);
	}

	addSchemaRule = (item) => {
		if (this.schema.findIndex(r => r.name === item.name) !== -1) {
			this.schema.push(item);
		}
	}

	removeSchemaRule = (name) => {
		const index = this.schema.findIndex(r => r.name === name);

		if (index === -1) {
			console.warn('Не найдено правило для удаления.') //eslint-disable-line
		}

		this.schema.slice(index, 1);
	}

	clearFieldsErrors = () => {
		this.schema.forEach(item => {
			const fieldNode = this.findInputNode(item.name);
			fieldNode.classList.remove('error');
		});
	}

	validateField = (item) => {
		const fieldNode = this.findInputNode(item.name);
		const value = fieldNode.value;
		const rules = item.rules.split('|');

		rules.forEach(rule => {
			switch(rule) {
				case 'required':
					if (!value) {
						this.errors.push(`Поле ${item.fieldName} должно быть заполнено`);
						fieldNode.classList.add('error');
						return;
					}
					break;
				case 'minLength':
					if (value.length < rule.minLength) {
						this.errors.push(`Поле ${item.fieldName} должно содержать не менее ${rule.minLength} символов`);
						fieldNode.classList.add('error');
						return;
					}
					break;
				case 'email':
					if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) && value.length) {
						this.errors.push(`Введите корректный email адрес`);
						fieldNode.classList.add('error');
						return;
					}
					break;
				case 'alphaNumeric':
					if (!/^[A-Za-zА-Яа-я0-9]+$/.test(value) && value.length) {
						this.errors.push(`Поле ${item.fieldName} может содержать только латинские буквы, буквы кириллицы и цифры`);
						fieldNode.classList.add('error');
						return;
					}
					break;
				case 'alphaSymbols':
					if (!/^[A-Za-zА-Яа-я-' ]+$/.test(value) && value.length) {
						this.errors.push(`Поле ${item.fieldName} может содержать только латинские буквы, буквы кириллицы и символы: -_'`);
						fieldNode.classList.add('error');
						return;
					}
					break;
				case 'custom':
					if (rule.customRule && !rule.customRule(value) && value.length) {
						this.errors.push(rule.errorMessage);
						fieldNode.classList.add('error');
						return;
					}
					break;
			}
		});
	}

	validateForm = () => {
		this.errors = [];
		this.clearFieldsErrors();
		this.schema.forEach(this.validateField);

		return this.errors.length ? { valid: false, errors: this.errors} : { valid: true }
	}
}

export default Validator;



// WEBPACK FOOTER //
// ./helpers/validation.js